import React from 'react';
import { View, StyleSheet } from 'react-native';

import { useTheme } from '@/components/theme-provider';

export interface ProgressBarProps {
	progress: number; // 0 to 1
	color?: string;
	style?: any;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
	progress,
	color,
	style,
}) => {
	const theme = useTheme();
	const progressColor = color || theme.colors.primary;

	return (
		<View style={[styles.container, style]}>
			<View
				style={[
					styles.progress,
					{
						width: `${Math.max(0, Math.min(100, progress * 100))}%`,
						backgroundColor: progressColor,
					},
				]}
			/>
		</View>
	);
};

const styles = StyleSheet.create({
	container: {
		height: 4,
		backgroundColor: '#e0e0e0',
		borderRadius: 2,
		overflow: 'hidden',
	},
	progress: {
		height: '100%',
		borderRadius: 2,
	},
});
